var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_793_172)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.2412 2.89402C10.6712 2.89402 9.37464 1.87499 7.40082 1.87499C6.66972 1.87499 6.01481 2.00343 5.40731 2.22693C5.49151 2.00705 5.52734 1.77161 5.51237 1.53664C5.46046 0.703554 4.77752 0.0353217 3.9435 0.00139593C3.0062 -0.0367486 2.23438 0.711787 2.23438 1.64061C2.23438 2.19802 2.51261 2.69018 2.9375 2.98666V14.2969C2.9375 14.6852 3.25229 15 3.64062 15H4.10938C4.4977 15 4.8125 14.6852 4.8125 14.2969V11.5312C5.64192 11.1778 6.67525 10.8831 8.16509 10.8831C9.73505 10.8831 11.0316 11.9022 13.0054 11.9022C14.4166 11.9022 15.5445 11.4248 16.5944 10.7052C16.8488 10.5308 17 10.2413 17 9.93295V2.81088C17 2.12554 16.289 1.67211 15.6674 1.9608C14.6614 2.42803 13.4276 2.89402 12.2412 2.89402Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_793_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS7);
export default __webpack_public_path__ + "static/media/s7.14c3dc14d0d99a5cba6764acfb019d02.svg";
export { ForwardRef as ReactComponent };